import { GiftIcon } from "@heroicons/react/outline";
import firebase from "firebase/app";
import { useTranslation } from "next-i18next";
import { useForm, Controller, useFormContext } from "react-hook-form";

import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";
import Heading from "@/features/common/components/tailwind/Heading";
import { Input } from "@/features/common/components/tailwind/Input";
import { Text } from "@/features/common/components/tailwind/Text";
import { TipsValueButton } from "@/features/tips/components/tipsPaymentDialog/TipsValueButton";

const DEFAULT_TIPS_AMOUNT = [10, 50, 100, 500];

export const TipsSummaryView = () => {
  const { t } = useTranslation("tips");
  const { control, setValue } = useFormContext();

  const setInputValue = (amount: number) => {
    firebase
      .analytics()
      .logEvent(AnalyticsEventEnum.TipsDialogDefaultValueSelected);
    setValue("amount", amount);
  };

  return (
    <div className="w-full flex flex-col bg-gray-50 p-5 mb-8">
      <Heading.H5 gutterBottom={true} className="text-20">
        {t("tips")}
      </Heading.H5>

      <div className="flex flex-row items-center">
        <GiftIcon
          width={70}
          height={70}
          strokeWidth={1}
          className="text-gray-500"
        />
        <div className="w-full flex flex-col gap-1">
          <div className="flex justify-between md:items-center flex-col md:flex-row">
            <Text size="small" className="text-gray-500">
              {t("tipsConfirmDialog.amount", { min: "5", max: 1000 })}
            </Text>

            <div className="grid gap-1 grid-cols-2 sm:grid-cols-4 ">
              {DEFAULT_TIPS_AMOUNT.map((amount, idx) => {
                return (
                  <TipsValueButton
                    onClick={() => {
                      setInputValue(amount);
                    }}
                    label={`$${amount}`}
                    key={"tips_amount_" + amount}
                  />
                );
              })}
            </div>
          </div>

          <Controller
            control={control}
            name="amount"
            render={({ field }) => {
              return (
                <Input
                  {...field}
                  placeholder={t("tipsConfirmDialog.customInputPlaceHolder")}
                />
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};
